// @ts-check
/**
 * @typedef {Object} ffClockCustomProperties
 * @property {Function} ffUpdateClock
 *
 * @typedef {ffClockCustomProperties & HTMLElement} FfClock
 */

if (!customElements.get("ff-clock")) {
  class FfClock extends HTMLElement {
    constructor() {
      super();

      /**
       * @type {HTMLElement}
       */
      // @ts-ignore
      this.ffClock = this.querySelector(this.dataset.ffOutputSelector);

      this.ffAnimationFrameId = requestAnimationFrame(this.ffUpdateClock);
    }

    ffUpdateClock = () => {
      const ibizaTime = new Intl.DateTimeFormat(undefined, {
        timeZone: "Europe/Madrid",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      }).format(new Date());

      const semanticTime = new Intl.DateTimeFormat(undefined, {
        timeZone: "Europe/Madrid",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
        timeZoneName: "long",
      }).format(new Date());

      this.ffClock.textContent = ibizaTime;
      this.ffClock.setAttribute("datetime", semanticTime);

      this.ffAnimationFrameId = requestAnimationFrame(this.ffUpdateClock);
    };
  }

  customElements.define("ff-clock", FfClock);
}
